document.addEventListener('DOMContentLoaded', function () {

  var calculators = document.querySelectorAll('.gfo-calculator-section');

  calculators.forEach(function (calculator) {

    var volumeInput = calculator.querySelector('#gfoTankVolume');
    var volumeToggle = calculator.querySelector('#gfoVolumeToggle');
    var productSelect = calculator.querySelector('#gfoProduct');
    var calculateButton = calculator.querySelector('#gfoCalculateButton');
    var resultBox = calculator.querySelector('#gfoResultBox');

    if (
      !volumeInput ||
      !volumeToggle ||
      !productSelect ||
      !calculateButton ||
      !resultBox
    ) {
      return;
    }

    var useLiters = false;

    function resetResult() {

      resultBox.classList.remove('is-calculated');

      resultBox.innerHTML =
        'Your recommended starting dose will appear here.';
    }

    function toggleVolumeUnit() {

      useLiters = !useLiters;

      volumeToggle.classList.toggle('is-active', useLiters);

      volumeToggle.setAttribute(
        'aria-pressed',
        useLiters ? 'true' : 'false'
      );

      volumeInput.placeholder = useLiters
        ? 'Enter volume in liters'
        : 'Enter volume in gallons';

      resetResult();
    }

function calculateGFO() {

  var volume = parseFloat(volumeInput.value);
  var product = productSelect.value;

  if (!volume || volume <= 0) {

    resultBox.classList.add('is-calculated');

    resultBox.innerHTML =
      '<p>Please enter a valid aquarium volume.</p>';

    return;
  }

  var gallons = useLiters
    ? volume / 3.78541
    : volume;

  var grams;
  var ounces;
  var dosageText;

  /*
    Reef Genetics Products
    1 gram per gallon
  */

  if (
    product === 'Reef Genetics GFO' ||
    product === 'Reef Genetics High Capacity GFO'
  ) {

    grams = gallons;
    ounces = grams / 28.3495;

    dosageText =
      '<p class="gfo-calculator-dose">' +
      grams.toFixed(1) +
      ' grams</p>' +

      '<p>Approximately <strong>' +
      ounces.toFixed(2) +
      ' oz</strong></p>';
  }

  /*
    RowaPhos
    100g per 100 gallons
    Equivalent to 1g per gallon
    But references manufacturer sizing
  */

  else if (product === 'RowaPhos') {

    grams = gallons;
    ounces = grams / 28.3495;

    dosageText =
      '<p class="gfo-calculator-dose">' +
      grams.toFixed(1) +
      ' grams</p>' +

      '<p>Approximately <strong>' +
      ounces.toFixed(2) +
      ' oz</strong></p>' +

      '<p>Based on manufacturer guidelines removing up to 3ppm phosphate.</p>';
  }

  resultBox.classList.add('is-calculated');

  resultBox.innerHTML = [
    '<h3>Recommended Starting Dose</h3>',

    '<p><strong>' + product + '</strong></p>',

    dosageText,

    '<p>Rinse before use and monitor phosphate levels weekly.</p>'
  ].join('');
}

    volumeToggle.addEventListener('click', toggleVolumeUnit);

    calculateButton.addEventListener('click', calculateGFO);

    volumeInput.addEventListener('input', resetResult);

    productSelect.addEventListener('change', resetResult);

  });

});